import { useState, useEffect } from "react";

/**
 * Carrega armazéns e localizações da clínica.
 * Devolve também helpers para selects encadeados.
 */
function useLocalizacoes({ sendRequest, clinicaId, auth, skip = false }) {
  const [armazens, setArmazens] = useState([]);
  const [localizacoes, setLocalizacoes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (skip || !clinicaId || !auth?.token) return;
    fetchTudo();
  }, [clinicaId, auth?.token, skip]);

  const fetchTudo = async () => {
    setLoading(true);
    try {
      const [resArm, resLoc] = await Promise.all([
        sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/armazens/clinica/${clinicaId}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        ),
        sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/localizacoes/clinica/${clinicaId}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token },
        ),
      ]);
      setArmazens((resArm.armazens || []).filter((a) => a.ativo));
      setLocalizacoes((resLoc.localizacoes || []).filter((l) => l.ativo));
    } catch (err) {
      console.error("Erro ao carregar localizações:", err);
    } finally {
      setLoading(false);
    }
  };

  /** Devolve só as localizações de um determinado armazém */
  const localizacoesPorArmazem = (armazemId) =>
    localizacoes.filter(
      (l) => l.armazem?.id === armazemId || l.armazem === armazemId,
    );

  /** Primeira localização activa de um armazém (útil como default) */
  const primeiraLocalizacao = (armazemId) =>
    localizacoesPorArmazem(armazemId)[0] || null;

  return {
    armazens,
    localizacoes,
    loading,
    localizacoesPorArmazem,
    primeiraLocalizacao,
  };
}

export default useLocalizacoes;
